// The plan screen's voice session, shared with the conversations and their composers. No
// provider means no voice: a composer outside a plan screen shows no voice control.

import { createContext, useContext } from 'react';

import type { Voice } from './useVoice.js';

export const VoiceContext = createContext<Voice | null>(null);

export function useVoiceContext(): Voice | null {
  return useContext(VoiceContext);
}
